export const SESSION_KEY_ERROR_CODES = {
  SESSION_EXPIRED: 'Session key expired',
  INCORRECT_SESSION_KEY: 'Incorrect session key',
  ATTEMPTS_EXCEEDED: 'Number of attempts exceeded',
  PASSWORD_CHANGE_DATA_NOT_FOUND: 'Password change data not found',
  SAVED_AUTH_DATA_NOT_FOUND: 'Saved auth data not found',
  MEMBER_ALREADY_ACTIVE: 'Member is already active',
  INVALID_LOGIN_PASSWORD: 'Member authentication error: "INVALID-LOGIN-PASSWORD"',
};

export const SESSION_KEY_ERROR_SET = new Set(Object.values(SESSION_KEY_ERROR_CODES));

export const SESSION_KEY_SUCCESS = {
  CHECK_RESULT_SUCCESS: '1',
  ACTIVE_REGISTRATION: '1',
  SESSION_PARAMS_TO_REMOVE: ['action', 'checkResult', 'memberId', 'email', 'reason'],
};

